import { render, staticRenderFns } from "./KintaiLinkInfoViewer.vue?vue&type=template&id=16b57a21&"
import script from "./KintaiLinkInfoViewer.vue?vue&type=script&lang=ts&"
export * from "./KintaiLinkInfoViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
